<style lang="less" scoped>
  @import "../../vars.less";
  .count-tip {
    padding: @space-small @space-normal 0 @space-normal;
    margin: 0 0 @space-small 0;
    font-size: 12px;
    color: @text-color-secondary;
  }
  .list {
    list-style: none;
    margin: 0;
  }
  .item {
    position: relative;
    display: flex;
    align-items: center;
    padding: @space-normal @space-normal;
    margin-bottom: @space-small;
    background-color: #fff;
  }
  .pic {
    width: 64px;
    height: 64px;
    flex: none;
  }
  .info {
    flex: auto;
    font-size: 14px;
    color: @text-color;
  }
  .name-zh {
    margin: 0;
    font-weight: 600;

  }
  .name-en {
    margin: 0 0 @space-small 0;
    font-size: 12px;
  }
  .code {
    font-size: 12px;
    color: @text-color-secondary;
    p {
      margin: 0;
      padding: 0;
    }
  }
  .exist {
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 16px;
    font-size: 10px;
    color: #fff;
    text-align: center;
    background-image: url("/images/corner.svg");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .item.more,
  .item.tip
   {
    font-size: 12px;
    color: @primary-color;
    text-align: center;
    display: block;
  }
  .item.tip {
    color: @text-color-secondary;
  }
  .new-customer-btn {
    margin-top: @space-small;
  }

</style>
<style lang="less">
  @import "../../vars.less";
  .van-nav-bar {
    background-color: @background-color !important;
  }
</style>

<template>
  <page-container class="customer-list" :title="$t('我的客户')" :loading="loading" :safeAreaInsetBottom="false" :empty="!items.length">
    <p class="count-tip">
      {{$t('在本地信息库中找到家客户', { count })}}
    </p>
    <ul class="list">
      <li v-for="item of items" :key="item.Pkey" class="item" @click="() => go2Detail(item)">
        <!-- look at this fucking disgusting api fields!! -->
        <template v-if="item.SourceName === '本地信息库'">
          <img class="pic" src="/images/e2e.png" />
          <div class="info">
            <h4 class="name-zh">{{ item.Name }}</h4>
            <p class="name-en">{{ item.EnName }}</p>
            <div class="code">
              <p>{{ $t('SI客户编码') }}: {{ item.Code }}</p>
              <p>IFA: {{ item.IFA }}</p>
            </div>
          </div>
        </template>
        <template v-if ="item.SourceName === '企查查'">
          <img class="pic" src="/images/qcc.png" />
          <div class="info">
            <h4 class="name-zh">{{ item.Name }}</h4>
            <van-button round plain
              class="new-customer-btn"
              type="info" size="small"
              icon="plus"
              @click="evt => apply(evt, item)">{{$t('新客户申请')}}</van-button>
          </div>
        </template>
        <!-- <div class="exist" v-if="item.BizStatus && item.BizStatus.trim()">{{ item.BizStatus }}</div> -->
        <div class="exist">{{ item.Status || item.BizStatus }}</div>
      </li>
      <li class="item more" @click="getMore" v-show="items.length && !alreadyLoadMore">
        <a class="more-link">
          {{ $t('查看更多') }}
          <van-icon name="arrow-down" />
        </a>
      </li>
      <li class="item tip" v-show="alreadyLoadMore">
        {{ $t('以上都不是，请通过PC端手动提交申请') }}
      </li>
    </ul>
  </page-container>
</template>

<script>
import { Icon, Button, Toast } from 'vant'
import PageContainer from '../../components/PageContainer.vue'

export default {
  name: 'customer-list',
  components: {
    'van-icon': Icon,
    'van-button': Button,
    PageContainer
  },
  data () {
    return {
      alreadyLoadMore: false,
      loading: false,
      count: 0,
      items: []
    }
  },
  watch: {
    count (v) {
      if (v > 30) {
        Toast(this.$t('查询数据过多，请提供更多名称信息'))
      }
    }
  },
  methods: {
    getList () {
      this.$apis.customer.getList(
        {
          ...this.$route.query,
          isMore: false
        },
        loading => (this.loading = loading)
      ).then(res => {
        if (res) {
          this.items = res.CustomerList
          this.count = res.SearchCount
        }
      })
    },
    getMore () {
      this.$apis.customer.getList(
        {
          ...this.$route.query,
          isMore: true
        },
        loading => (this.loading = loading)
      ).then(res => {
        if (res) {
          this.items = res.CustomerList
          this.alreadyLoadMore = true
        }
      })
    },
    apply (evt, item) {
      evt.stopPropagation()
      this.$router.push({
        name: 'customer-apply',
        params: {
          stackType: 'push'
        },
        query: { Pkey: item.Pkey, Name: item.Name }
      })
    },
    go2Detail (item) {
      if (item.SourceName === '企查查') {
        return
      }
      this.$router.push({
        name: 'customer-detail',
        params: {
          stackType: 'push'
        },
        query: {
          Pkey: item.Pkey,
          Name: item.Name,
          Code: item.Code
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name === 'customer-apply') {
        vm.getMore()
      }
    })
  },
  mounted () {
    this.getList()
  }
}
</script>
